











import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import MultiProfessionListSelector from "../../../../profession/selectors/MultiProfessionListSelector.vue";
import { MultiProfessionListUserFilterableMixin } from "../../mixins";

@Component({
  components: {
    MultiProfessionListSelector,
  },
})
export default class MultiProfessionListUserFilter extends Mixins(ModelEditableMixin, MultiProfessionListUserFilterableMixin) {
  async mounted(): Promise<void> {
    this.professionsSource = await this.getDefaultSelectedProfessions();
  }
}
